// AppShell — 2-column layout: sidebar + main content.
// Also wires Electron deep-link / tray-nav handlers to react-router.
import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";
import { electron, isDesktop } from "@/utils/electron";

export function AppShell() {
  const nav = useNavigate();

  useEffect(() => {
    if (!isDesktop) return;
    const offDeep = electron.onDeepLink((url) => {
      // hasyapi://invoices/abc123  ->  /invoices/abc123
      try {
        const u = new URL(url);
        const target = "/" + u.host + u.pathname;
        nav(target.replace(/\/+/g, "/"));
      } catch { /* ignore */ }
    });
    const offNav = electron.onNav((route) => nav(route));
    return () => { offDeep?.(); offNav?.(); };
  }, [nav]);

  return (
    <div className="min-h-screen bg-background flex safe-top">
      <aside className="hidden lg:block w-64 shrink-0 border-r border-border bg-card sticky top-0 h-screen safe-left">
        <Sidebar />
      </aside>
      <div className="flex-1 min-w-0 flex flex-col">
        <TopBar />
        <main className="app-content flex-1 p-3 sm:p-4 md:p-6 max-w-full overflow-x-hidden safe-x safe-bottom">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
